import { actionTypes } from "../../actions/action_types";

const initialState = {
  unredeemed_pawns_list: {
    newPawnSummaries: {
      totalPieces: 0,
      totalPrincipal: 0,
    },
    pastDueSummaries: {
      totalPieces: 0,
      totalPrincipal: 0,
    },
    overDueSummaries: {
      totalPieces: 0,
      totalPrincipal: 0,
    },
    longOverDueSummaries: {
      totalPieces: 0,
      totalPrincipal: 0,
    },
  },
};

export default function unredeemedpawn_reducer(state = initialState, action) {
  var stateCopy = Object.assign({}, state);

  switch (action.type) {
    case actionTypes.REPORTS_UNREDEEMEDPAWNS_GET_OVERALL:
      stateCopy.unredeemed_pawns_list = action.payload;
      return stateCopy;

    case actionTypes.REPORTS_UNREDEEMEDPAWNS_GET_CLUSTER:
      stateCopy.unredeemed_pawns_list = action.payload;
      return stateCopy;

    case actionTypes.REPORTS_UNREDEEMEDPAWNS_GET_AREA:
      stateCopy.unredeemed_pawns_list = action.payload;
      return stateCopy;

    case actionTypes.REPORTS_UNREDEEMEDPAWNS_GET_BRANCH:
      stateCopy.unredeemed_pawns_list = action.payload;
      return stateCopy;

    default:
      return state;
  }
}
